import React from 'react';

import EvaluacionNivelView from '../components/evaluaciones/EvaluacionNivelView';
import { obtenerModulosNivel } from '../config/evaluacionesCatalogo';
import { M1_Ejercicio10 } from '../components/evaluaciones/Basico/Modulo1/Ejercicio10';
import Ejercicio11 from '../components/evaluaciones/Basico/Modulo1/Ejercicio11';
import Ejercicio7 from '../components/evaluaciones/Basico/Modulo2/Ejercicio7';
import Ejercicio9 from '../components/evaluaciones/Basico/Modulo3/Ejercicio9';
import Ejercicio10 from '../components/evaluaciones/Basico/Modulo3/Ejercicio10';
import M4Ejercicio7 from '../components/evaluaciones/Basico/Modulo4/m4_ejercicio7';
import M4_Ejercicio8 from '../components/evaluaciones/Basico/Modulo4/M4Ejecicio8';
import M4_Ejercicio9 from '../components/evaluaciones/Basico/Modulo4/M4_Ejercicio9';
import M4_Ejercicio10 from '../components/evaluaciones/Basico/Modulo4/M4_Ejercicio10';
import M5_Ejercicio7 from '../components/evaluaciones/Basico/Modulo5/M5_Ejercicio7';
import M5_Ejercicio8 from '../components/evaluaciones/Basico/Modulo5/M5_Ejercicio8';
import M5_Ejercicio9 from '../components/evaluaciones/Basico/Modulo5/M5_Ejercicio9';
import M5_Ejercicio10 from '../components/evaluaciones/Basico/Modulo5/M5_Ejercicio10';

const componentes = {
  basico_modulo1_1: M1_Ejercicio10,
  basico_modulo1_2: Ejercicio11,
  basico_modulo2_3: Ejercicio7,
  basico_modulo3_4: Ejercicio9,
  basico_modulo3_5: Ejercicio10,
  basico_modulo4_6: M4Ejercicio7,
  basico_modulo4_7: M4_Ejercicio8,
  basico_modulo4_8: M4_Ejercicio9,
  basico_modulo4_9: M4_Ejercicio10,
  basico_modulo5_10: M5_Ejercicio7,
  basico_modulo5_11: M5_Ejercicio8,
  basico_modulo5_12: M5_Ejercicio9,
  basico_modulo5_13: M5_Ejercicio10,
};

const modulos = obtenerModulosNivel('basico', componentes);

const EvaluacionBasica = () => (
  <EvaluacionNivelView nivel="basico" titulo="Nivel 1 Básico" modulos={modulos} />
);

export default EvaluacionBasica;
